import { Component, OnInit, ChangeDetectionStrategy, Input, Output, EventEmitter, AfterViewInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-responsive-tab',
  templateUrl: './responsive-tab.component.html',
  styleUrls: ['./responsive-tab.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ResponsiveTabComponent implements OnInit, AfterViewInit {

  constructor(private route: ActivatedRoute, private router: Router) { }

  ngOnInit() {
    if (this.navigateParam) {
      this.route.queryParams.subscribe(async params => {
        let tab = params[this.navigateParam] || this.default;
        this.setTab(tab, false);
      });
    } else
      this.setTab(this.default);
  }

  ngAfterViewInit(): void {
    let active = this.tabs.filter(_ => _.active).pop();
    if (active)
      this.active.emit(active);
  }

  @Input('default') default: string;
  @Input('containerClasses') containerClasses: string = 'container';
  @Input('tabs') tabs: { name: string, title?: string, active?: boolean }[];
  @Input('navigate') navigateParam: string;
  @Output() active = new EventEmitter<{ name: string, title?: string, active?: boolean }>();

  selected: string;

  setTab(tab: string, navigate = true) {
    this.tabs = this.tabs.filter(_ => _);
    this.tabs.forEach(_ => _.active = _.name == tab);
    var activeTab = this.tabs.find(_ => _.active) || this.tabs[0];
    activeTab.active = true;

    this.active.emit(activeTab);
    this.selected = activeTab.name;
    if (navigate && this.navigateParam) {
      let params = {};
      params[this.navigateParam] = tab;
      this.router.navigate([], { relativeTo: this.route, queryParams: params });
    }
  }


}
